import _extends from "@babel/runtime/helpers/extends";
import { Query, QueryExpression, QueryOperators } from '@sensenet/query';
import React, { useEffect, useState } from 'react';
import Autosuggest from 'react-autosuggest';
import { ReferenceFieldContainer } from "./ReferenceFieldContainer.js";
import { ReferenceFieldInput } from "./ReferenceFieldInput.js";
import { ReferenceFieldSuggestion } from "./ReferenceFieldSuggestion.js";
/**
 * Props for the ReferenceField component
 */

/**
 * Reference field picker component
 */
export function ReferenceField(props) {
  var _props$fieldSetting$D, _props$fieldSetting, _props$fieldSetting2, _ref, _props$helperText, _props$fieldSetting3;

  const [inputValue, setInputValue] = useState('');
  const [items, setItems] = useState([]);
  const displayName = (_props$fieldSetting$D = (_props$fieldSetting = props.fieldSetting) === null || _props$fieldSetting === void 0 ? void 0 : _props$fieldSetting.DisplayName) !== null && _props$fieldSetting$D !== void 0 ? _props$fieldSetting$D : props.label;
  const description = ((_props$fieldSetting2 = props.fieldSetting) === null || _props$fieldSetting2 === void 0 ? void 0 : _props$fieldSetting2.Description) || '';
  const helperText = (_ref = (_props$helperText = props.helperText) !== null && _props$helperText !== void 0 ? _props$helperText : (_props$fieldSetting3 = props.fieldSetting) === null || _props$fieldSetting3 === void 0 ? void 0 : _props$fieldSetting3.Description) !== null && _ref !== void 0 ? _ref : '';
  const inputProps = {
    value: inputValue,
    onChange: ev => onChange(ev.target.value),
    id: 'CommandBoxInput'
  };
  useEffect(() => {
    ;

    (async () => {
      if (props.defaultValueIdOrPath) {
        const fetchedItems = await props.fetchItems(new Query(q => isNaN(props.defaultValueIdOrPath) ? q.equals('Path', props.defaultValueIdOrPath) : q.equals('Id', props.defaultValueIdOrPath)));

        if (fetchedItems.length === 1 && fetchedItems[0]) {
          var _props$onQueryChange;

          const [item] = fetchedItems;
          setInputValue(item.DisplayName || item.Name);
          (_props$onQueryChange = props.onQueryChange) === null || _props$onQueryChange === void 0 ? void 0 : _props$onQueryChange.call(props, props.fieldKey || props.fieldName.toString(), new Query(q => q.equals(props.fieldName, item.Id)));
        }
      }
    })(); // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  useEffect(() => {
    if (props.triggerClear) {
      setInputValue('');
    }
  }, [props.triggerClear]);

  const onChange = value => {
    var _props$onChange;

    setInputValue(value);
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, null);
  };

  const getSuggestionValue = c => {
    return c.DisplayName || c.Name;
  };

  const onSuggestionSelected = (_ev, data) => {
    _ev.preventDefault();

    handleSelect(data.suggestion);
  };
  /**
   *
   * @param term AutoComplete field value
   */


  function getQueryFromTerm(term) {
    var _props$fieldSetting$A, _props$fieldSetting$S;

    const query = new Query(q => q.query(q2 => q2.equals('Name', term).or.equals('DisplayName', term).or.equals('Path', term)));

    if ((_props$fieldSetting$A = props.fieldSetting.AllowedTypes) !== null && _props$fieldSetting$A !== void 0 && _props$fieldSetting$A.length) {
      new QueryOperators(query).and.query(q2 => {
        ;
        props.fieldSetting.AllowedTypes.forEach((allowedType, index, array) => {
          new QueryExpression(q2.queryRef).term(`TypeIs:${allowedType}`);

          if (index < array.length - 1) {
            return new QueryOperators(q2.queryRef).or;
          }
        });
        return q2;
      });
    }

    if ((_props$fieldSetting$S = props.fieldSetting.SelectionRoots) !== null && _props$fieldSetting$S !== void 0 && _props$fieldSetting$S.length) {
      new QueryOperators(query).and.query(q2 => {
        ;
        props.fieldSetting.SelectionRoots.forEach((root, index, array) => {
          new QueryExpression(q2.queryRef).inTree(root);

          if (index < array.length - 1) {
            return new QueryOperators(q2.queryRef).or;
          }
        });
        return q2;
      });
    }

    return query;
  }

  const handleSelect = item => {
    var _props$onChange2, _props$onQueryChange2;

    (_props$onChange2 = props.onChange) === null || _props$onChange2 === void 0 ? void 0 : _props$onChange2.call(props, item);
    setInputValue(item.DisplayName || item.Name);
    (_props$onQueryChange2 = props.onQueryChange) === null || _props$onQueryChange2 === void 0 ? void 0 : _props$onQueryChange2.call(props, props.fieldKey || props.fieldName.toString(), new Query(q => q.equals(props.fieldName, item.Id)));
  };

  return /*#__PURE__*/React.createElement(Autosuggest, _extends({}, props.autoSuggestProps, {
    theme: {
      suggestionsList: {
        listStyle: 'none',
        margin: 0,
        padding: 0
      }
    },
    suggestions: items,
    onSuggestionsFetchRequested: async req => {
      const query = getQueryFromTerm(`*${req.value}*`);
      const fetchedItems = await props.fetchItems(query);
      setItems(fetchedItems);
    },
    onSuggestionsClearRequested: () => {
      setItems([]);
    },
    getSuggestionValue: getSuggestionValue,
    renderSuggestion: (item, suggestionProps) => /*#__PURE__*/React.createElement(ReferenceFieldSuggestion, {
      item: item,
      query: suggestionProps.query,
      isHighlighted: suggestionProps.isHighlighted
    }),
    inputProps: inputProps,
    renderInputComponent: inputComponentProps => /*#__PURE__*/React.createElement(ReferenceFieldInput, {
      displayName: displayName,
      description: description,
      helperText: helperText,
      inputProps: inputComponentProps,
      autoFocus: props.autoFocus
    }),
    renderSuggestionsContainer: ReferenceFieldContainer,
    onSuggestionSelected: onSuggestionSelected
  }));
}
//# sourceMappingURL=ReferenceField.js.map